import { Box, Paper, Typography } from '@mui/material';
import { PaginationBlock } from 'ui/PaginationBlock';
import { EasTable } from 'ui/EasTable';
import { EasTableFilterPanel } from 'ui/EasTableFilterPanel';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { IEmReportsItemResponse, ItemWithId } from '../data/types';
import { TEasVatNumberReportsProps } from './types';
import { saveUrl } from '../../../redux/reducers/auth/reducer';
import { EasTableWithFilter } from '../../../ui/EasTableWithFilter';
import { PAGE_SIZE } from 'services/constants/env';

export const EasVatNumberReports = <
	TResponse extends IEmReportsItemResponse<TItem>,
	TItem extends ItemWithId,
>({
	tableStructure,
	items,
	itemsIsLoading,
	handleAction,
}: TEasVatNumberReportsProps<TResponse, TItem>) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	// const items = { data: emLevelData, totalCount: 75, pageNumber: 1 };
	// const tableStructure = emReportsStructure as TTableStructure<keyof TEmLevelItem>[];
	// const itemsIsLoading = false;

	const handleLink = (id: number) => {
		dispatch(saveUrl(window.location.pathname + window.location.search));
		navigate(`/hmrc/${id}`);
	};

	return (
		<Box>
			<Box sx={{ width: 'auto', minWidth: '1400px', margin: '0px 10px 0 10px' }}>
				<Box sx={{ borderRadius: '12px' }}>
					{/* <Box sx={{ backgroundColor: 'primary.light', p: 0.5 }}>
							<Navigator />
						</Box> */}

					{/* <EasTableFilterPanel tableStructure={tableStructure} /> */}
					<EasTableWithFilter<TItem>
						tableStructure={tableStructure}
						items={{
							data: items?.data ?? [],
							pageNumber: 1,
							pageSize: PAGE_SIZE,
							totalCount: items?.totalCount ?? 0,
						}}
						itemsIsLoading={itemsIsLoading}
						handleAction={handleAction}
						handleLink={handleLink}
					>
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								width: '100%',
								padding: '0 0 0 8px',
							}}
						>
							<Typography variant="body1" color="primary" fontWeight="bold">
								HMRC Reports
							</Typography>
						</Box>
					</EasTableWithFilter>
				</Box>
			</Box>
		</Box>
	);
};
